import { useNavigate } from 'react-router-dom';
import { ShieldX } from 'lucide-react';

export function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center text-white">
      <div className="text-center max-w-md px-6">
        <ShieldX className="w-16 h-16 mx-auto mb-6 text-red-500" />
        <h1 className="text-2xl font-bold mb-2">Acesso Negado</h1>
        <p className="text-slate-400 mb-8">
          Você não tem permissão para acessar o Sistema Master. Entre em contato com um administrador.
        </p>
        <button
          onClick={() => navigate('/login')}
          className="px-6 py-2.5 bg-white/10 hover:bg-white/20 border border-white/20 rounded-lg transition-colors"
        >
          Voltar ao login
        </button>
      </div>
    </div>
  );
}
